import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { IdService } from '../../../shared/services/id.service';
import { StepsDataService } from '../stepsData/steps-data.service';

@Component({
	selector: 'rbc-stepper-content',
	templateUrl: './stepper-content.component.html',
	styleUrls: ['./stepper-content.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class StepperContentComponent implements OnDestroy {
	@Input() checked: boolean = false;
	_completed: boolean = false;
	@Input() disabled: boolean = false;
	@Input() helpText: string;
	@Input() id: string;
	@Input() label: string;
	_passed: boolean = false;
	active;

	// Banana in a box implementation of completed
	@Input()
	get completed() {
		return this._completed;
	}
	set completed(val) {
		this._completed = val;
		this.completedChange.emit(this._completed);
	}
	@Output() completedChange = new EventEmitter<boolean>();

	@Input()
	get passed() {
		return this._passed;
	}
	set passed(val) {
		this._passed = val;
		this.passedChange.emit(this._passed);
	}
	@Output() passedChange = new EventEmitter<boolean>();

	isActive: boolean = false;
	index: number = 0;

	constructor(private idService: IdService, private stepsDataService: StepsDataService) {
		this.id = idService.generate();
	}

	get currentStepID(): string {
		return this.stepsDataService.currentStepID;
	}

	set currentStepID(index: string) {
		this.stepsDataService.currentStepID = index;
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	completeProgress(val) {
		this.completed = val;
		this.active = false;
	}
}
